const AbstractPayyoRequestRecord = require('./AbstractPayyoRequestRecord');

class PayyoCapturePaymentRequestRecord extends AbstractPayyoRequestRecord {
    /**
     * An id for a payment in Payyo beginning with py_ (probably matching ^py_[a-zA-Z0-9]{32}$ tbc).
     *
     * @param {string} paymentId
     */
    constructor(paymentId) {
        if (!paymentId || !paymentId.startsWith('py_')) {
            throw new Error('A valid paymentId is required');
        }
        super(
            'POST',
            'payments/' + paymentId + '/capture',
        );
    }
}

module.exports = PayyoCapturePaymentRequestRecord;
